import {
  FETCH_USER_GEAR,
} from './constants'

export function fetchUserGear () {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: FETCH_USER_GEAR,
      payload: mapmy.getUserGear({ limit: 40, offset: 0 }),
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/userGear/actions.js